import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-compass-3-fill text-base text-background-50"></i>
              </div>
              <span className="text-lg font-semibold font-[var(--font-heading)]">
                KAIYUN导航
              </span>
            </div>
            <p className="text-sm text-background-50/60 leading-relaxed">
              致力于为用户提供 kaiyun.con 官方入口的完整导航指引、平台介绍及常见问题解答服务。
            </p>
          </div>
          <div>
            <h4 className="text-sm font-semibold mb-4">
              <a href="/categories" className="text-background-50 no-underline hover:text-primary-400 transition-colors">
                内容分类
              </a>
            </h4>
            <ul className="space-y-2">
              <li><Link to="/categories" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">访问指南</Link></li>
              <li><Link to="/categories" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">平台介绍</Link></li>
              <li><Link to="/categories" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">常见问题</Link></li>
              <li><Link to="/categories" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">使用教程</Link></li>
              <li><Link to="/categories" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">最新动态</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-semibold mb-4">
              <a href="/about" className="text-background-50 no-underline hover:text-primary-400 transition-colors">
                关于我们
              </a>
            </h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">品牌介绍</Link></li>
              <li><Link to="/about" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">平台信誉</Link></li>
              <li><Link to="/about" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">联系方式</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-semibold mb-4">快捷入口</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">网站首页</Link></li>
              <li><Link to="/categories" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">分类导航</Link></li>
              <li><Link to="/about" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">联系我们</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-10 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40">
            &copy; {currentYear} KAIYUN导航. 本站为第三方导航指引网站，非 kaiyun.con 官方网站.
          </p>
          <p className="text-xs text-background-50/40">
            本站内容仅供参考，请以官方平台信息为准
          </p>
        </div>
      </div>
    </footer>
  );
}